import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ClaimsAuthzService } from '@mri-platform/resource-authz';
import { RegisteredEntityMetaDataService } from '@mri-platform/shared/core';
import { BreezeEntityModuleConfig } from '@mri/breeze-entity';
import { BreezeEntityClaimsAuthzService } from './breeze-entity-claims-authz.service';
import { BreezeRegisteredEntityMetaDataService } from './breeze-registered-entity-meta-data.service';
import { ClearEntityCacheProvider } from './clear-entity-cache';
import { DefaultBreezeLibraryConfigProvider } from './default-breeze-library-config.provider';

export const defaultBreezeEntityConfig: BreezeEntityModuleConfig = {
  propertyOptions: { requiredCssClass: 'k-required' }
};

export function provideAppBreezeIntegration(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DefaultBreezeLibraryConfigProvider,
    ClearEntityCacheProvider,
    {
      provide: RegisteredEntityMetaDataService,
      useExisting: BreezeRegisteredEntityMetaDataService
    },
    { provide: ClaimsAuthzService, useExisting: BreezeEntityClaimsAuthzService }
  ]);
}
